import { useTariffStore } from '@/features/Tariffs/store';
import type { StepConfig } from '@/router/types';
import { useStepValidators } from '@/router/utils/useStepValidators';

const { tariffsResultMatchesSearch, tariffsSelected, isCompanyClientBlocked } =
  useStepValidators();

const stepConfig: StepConfig = {
  path: 'vergleich/:id?',
  routeName: 'comparison',

  props: {
    icon: 'exchange-alt',
    label: () =>
      useTariffStore().selection.length === 1 ? '3 Leistungen' : '3 Vergleich',
    isValid: () =>
      !isCompanyClientBlocked() &&
      tariffsResultMatchesSearch() &&
      tariffsSelected(),
  },

  beforeEnter: (to, _from, next) => {
    if (to.params.id !== undefined && to.params.id !== '') {
      useTariffStore().selection = [to.params.id as string];
    }
    next();
  },
};

export default stepConfig;
